import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { SubscribeApps } from '@/comm/app'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export const createSubscribeAppStore = (init = 'total', key = '') =>
  create(
    persist((set) => ({ value: init, update: (value) => set({ value }) }), {
      name: `subscribe-app-storage-${key}`,
      storage: createJSONStorage(() => localStorage),
    }),
  )

export const useSubscribeApp = createSubscribeAppStore('total')

const AppSelect = ({ value, onValueChange }) => {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Select app" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Select App</SelectLabel>
          {SubscribeApps.map((app) => (
            <SelectItem key={app.code} value={app.code}>
              {app.name}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}

export default AppSelect
